import OtherPlatforms from "./OtherPlatforms";

export default OtherPlatforms;